export default "__VITE_ASSET__Cr52TU1l__"